import styled from 'styled-components';

const StyledForgotPasswordView = styled.div`
  width: 100%;
  transition: all 0.5s ease-in;
`;

const Container = styled.div`
  max-width: 418px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 20px;
`;

const Title = styled.h3`
  font-weight: bold;
  font-size: 2rem;
  margin: 0;
  letter-spacing: 0;
  line-height: 47px;
  ${({ theme }) => `
    color: ${theme.colors.blue};

    ${theme.breakPoints.tablet} {
      font-size: 2.4rem;
    }
  `};
`;

const Subtitle = styled.span`
  font-size: 1.6rem;
  color: #333;
  letter-spacing: 0;
  font-weight: 300;
  line-height: 21px;
  text-align: center;
`;

const LabelsWrapper = styled.form`
  padding: 0px;
  box-sizing: border-box;
  width: 100%;
  text-align: center;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 20px 0;

  font-size: 18px;
  color: #657480;
  letter-spacing: 4.5px;
  text-transform: uppercase;
`;

const ErrorMessage = styled.span`
  display: inline;
  color: #ff0039;
  font-size: 1.2rem;
  text-align: left;
  letter-spacing: 0px;
  text-transform: none;
  padding: 10px 0;
`;

export default StyledForgotPasswordView;

export {
  StyledForgotPasswordView,
  Container,
  Title,
  Subtitle,
  LabelsWrapper,
  InputGroup,
  ErrorMessage,
};
